import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';

import type { BlogPostSummary } from '../../api/blog';
import { formatDate } from '../../lib/format';

/** One article in a list: the index, a tag page, "related" under an article, the homepage. */
export function PostCard({ post, prefix, locale }: { post: BlogPostSummary; prefix: string; locale: string }) {
  const { t } = useTranslation();

  return (
    <article className="l-post-card">
      {post.coverImageUrl && (
        <Link to={`${prefix}/blog/${post.slug}`} tabIndex={-1} aria-hidden="true">
          <img className="l-post-card__cover" src={post.coverImageUrl} alt="" loading="lazy" />
        </Link>
      )}
      <div className="l-post-card__body">
        <p className="l-post-meta">
          <time dateTime={post.publishedAt}>{formatDate(post.publishedAt, locale)}</time>
          <span aria-hidden="true"> · </span>
          {t('blog.minutes', { count: post.readingMinutes })}
        </p>
        <h2>
          <Link to={`${prefix}/blog/${post.slug}`}>{post.title}</Link>
        </h2>
        <p>{post.excerpt}</p>
        {post.tags.length > 0 && (
          <p className="l-post-tags">
            {post.tags.map((tag) => (
              <Link key={tag.slug} to={`${prefix}/blog/tag/${tag.slug}`}>
                {tag.name}
              </Link>
            ))}
          </p>
        )}
      </div>
    </article>
  );
}
